import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from "semantic-ui-react/dist/es/elements/Button/Button.js";
import { Icon } from "../Icon";
export var Component = function Component(_ref) {
  var children = _ref.children,
      hasShadow = _ref.hasShadow,
      icon = _ref.icon,
      isCompact = _ref.isCompact,
      isDisabled = _ref.isDisabled,
      isFluid = _ref.isFluid,
      isFormSubmit = _ref.isFormSubmit,
      isLoading = _ref.isLoading,
      isOutlined = _ref.isOutlined,
      isPositionedRight = _ref.isPositionedRight,
      isRounded = _ref.isRounded,
      isSecondary = _ref.isSecondary,
      onClick = _ref.onClick,
      size = _ref.size;
  return React.createElement(Button, {
    basic: isOutlined,
    circular: isRounded,
    className: classnames({
      'has-shadow': !!hasShadow,
      'has-outline': !!isOutlined
    }),
    compact: isCompact,
    disabled: isDisabled,
    floated: isPositionedRight ? 'right' : 'left',
    fluid: isFluid,
    loading: isLoading,
    onClick: onClick,
    secondary: isSecondary,
    size: size,
    type: isFormSubmit ? 'submit' : 'button'
  }, !!icon && React.createElement(Icon, {
    name: icon
  }), children);
};
Component.displayName = 'Button';
Component.defaultProps = {
  children: null,
  hasShadow: false,
  icon: null,
  isCompact: false,
  isDisabled: false,
  isFluid: false,
  isFormSubmit: false,
  isLoading: false,
  isOutlined: false,
  isPositionedRight: false,
  isRounded: false,
  isSecondary: false,
  onClick: Function.prototype,
  size: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  hasShadow: PropTypes.bool,
  icon: PropTypes.string,
  isCompact: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isFluid: PropTypes.bool,
  isFormSubmit: PropTypes.bool,
  isLoading: PropTypes.bool,
  isOutlined: PropTypes.bool,
  isPositionedRight: PropTypes.bool,
  isRounded: PropTypes.bool,
  isSecondary: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.string
} : {};